"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatDateRange;

var _constants = require("./constants");

/**
 * @deprecated use `formatDateTimeRange` from `ha-intl`
 */
function formatDateRange(formatDate, startDate, endDate) {
  return [startDate, endDate].filter(Boolean).map(function (date) {
    return formatDate(_constants.DATE_RANGE_FORMAT, date);
  }).join(' - ');
}